import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=1bc94676&scoped=true&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=1bc94676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc94676",
  null
  
)

export default component.exports